export var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    iOS12: function () {
        return (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream;
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.iOS12() || isMobile.Opera() || isMobile.Windows());
    }
};

let decodeEntities = (function () {
    let cache = {},
        character,
        e = document.createElement('div');
    return function (html) {
        return html.replace(/([&][^&; ]+[;])/g, function (entity) {
            character = cache[entity];
            if (!character) {
                e.innerHTML = entity;
                if (e.childNodes[0])
                    character = cache[entity] = e.childNodes[0].nodeValue;
                else
                    character = '';
            }
            return character;
        });
    };
})();

export function flattenMessages(nestedMessages, applicationData, prefix = '') {
    return Object.keys(nestedMessages).reduce((messages, key) => {
        let value = decodeEntities(nestedMessages[key].replace("\\", ""));
        let prefixedKey = prefix ? `${prefix}.${key}` : key;
        if (typeof value === 'string') {
            messages[prefixedKey] = formatResourceMessages(nestedMessages, value);
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }
        return messages;
    }, {});
}

function formatResourceMessages(nestedMessages, rbValue) {
    let msg = rbValue.match(/\${([^}]+)\}/g)
    if (msg != undefined && msg != null) {
        msg.forEach(v => {
            if (v.includes("${key:")) {
                let fallbackMsg = nestedMessages[v.replace("${key:", "").replace("}", "")]
                rbValue = rbValue.replace(v, fallbackMsg)
            }
        })
    }
    return rbValue;
}

export function popupWin(file, width, height) {
    if (navigator.appName == "Microsoft Internet Explorer") {
        width = width + 20;
        height = height + 20;
    }

    if (parseInt(navigator.appVersion) < 4) {
        width = width + 20;
        height = height + 20;
    }
    window.open(file, "_blank", "width=800, height=600");
}

export function showInternalPopup(divId) {
}

export function isFirstPage(currentPage, pages) {
    return pages[0] == currentPage
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


